/**
 * Определяют типы полей, которые могут отображаться при генерации формы PageFormBuilder
 */
export enum StandardFormTypes {
  'varchars' = 'varchars',
  'text' = 'text',
  'const' = 'const',
  'int' = 'int',
  'bool' = 'bool',
  'empty' = 'empty',
  'item' = 'item',
  'list' = 'list',
  'filtereditem' = 'filtereditem',
  'itemlink' = 'itemlink',
  'enum' = 'enum',
  'expression' = 'expression',
  'date' = 'date',
  'datetime' = 'datetime',
  'radiogroup' = 'radiogroup',
  'template' = 'template',
  'json' = 'json',
  'dropdown' = 'dropdown',
  'listbutton' = 'listbutton',
  'readonly' = 'readonly',
  'numeric' = 'numeric'
}

export interface StandardFormEnum {
  id: number;
  name: string;
}


